// lib

import PropTypes from 'prop-types'
import classNames from 'classnames'

// components
import { Dropdown } from 'primereact/dropdown'
import OptionLabel from '@aytm/app/stats/page/question-views/components/controls/OptionLabel'

const itemTemplate = option =>
  option.hidden ? null : <OptionLabel name="oe-view-mode" value={option.key} html={option.text} />

const ViewModes = ({ model, data, onViewModeChange }) => {
  const { viewMode } = model

  return 2 > data.controls.viewModes.options.length || data.controls.viewModes.disabled ? null : (
    <div
      data-testid="stat-view-mode-control"
      className={classNames('p-fluid p-col-param', {
        'p-col-param-wide': 'tags' == viewMode,
        'p-col-param-mode': 'wordcloud' == viewMode
      })}
    >
      <Dropdown
        className="p-dropdown-rounded"
        aria-label="View mode"
        ariaLabel="View mode"
        value={viewMode}
        options={data.controls.viewModes.options}
        optionValue="key"
        optionLabel="text"
        optionDisabled="disabled"
        // valueTemplate={valueTemplate}
        fixedDropdownDir="bottom"
        disabled={data.controls.viewModes.disabled}
        itemTemplate={itemTemplate}
        onChange={data.controls.viewModes.disabled ? null : event => onViewModeChange(event.value)}
      />
    </div>
  )
}

ViewModes.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  onViewModeChange: PropTypes.func
}

ViewModes.displayName = 'ViewModes'

export default ViewModes
